import { Client } from 'urql';
import { headerCtasBySlugQuery } from './headerCtasBySlugQuery';

export const fetchHeaderCtasBySlug = async ({
  client,
  slug,
  propertyId,
  isPropertyReportEnabled,
}: {
  client: Client;
  slug: string;
  propertyId: string;
  isPropertyReportEnabled: boolean;
}) => {
  const { data, error } = await client
    .query(headerCtasBySlugQuery, {
      id: propertyId,
      slug,
      isPropertyReportEnabled,
    })
    .toPromise();
  return { data, error };
};
